<template>
  <div class="py-6 md:py-12">
    <div class="container mx-auto px-4">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Section'
}
</script>
